import {IController, IModule, IScope} from "angular";
import {regNavn} from "../../../../../felles/tjenester/tredjepartsTjenestenavn";
import {gettextCatalog} from "angular-gettext";
import {l} from "types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {MeldingTilBruker, Varighet} from "../../../../../felles/tjenester/MeldingTilBruker";
import {OppgaveTjenesteWeb} from "../../OppgaveTjenesteWeb";
import {OppgaveTjeneste} from "../../../../../felles/tjenester/modulspesifikke/OppgaveTjeneste";
import {EnumOversettelser} from "felles/tjenester/i18n/EnumOversettelser";

const css = require('./oppgaveStatusVelger.scss');

export class OppgaveStatusKomponent implements IController {
    static registrerKomponent(angular: IModule) {
        angular
          .component('woOppgaveStatus', {
              bindings: {
                  oppgave: '<',
                  spesifikasjon: '<',
              },
              controller: OppgaveStatusKomponent.forInjisering(),
              template: require('./oppgaveStatusVelger.html'),
              transclude: true
          })
    }

    static forInjisering() {
        return [
            regNavn.ng.$scope,
            OppgaveTjenesteWeb.regNavn,
            OppgaveTjeneste.regNavn,
            regNavn.gettext.gettextCatalog,
            EnumOversettelser.regNavn,
            MeldingTilBruker.regNavn,
            OppgaveStatusKomponent
        ]
    }

    constructor(private $scope: IScope,
                private oppgaveTjenesteWeb: OppgaveTjenesteWeb,
                private oppgaveTjeneste: OppgaveTjeneste,
                private gettextCatalog: gettextCatalog,
                private enumOversettelser: EnumOversettelser,
                private meldingTilBruker: MeldingTilBruker) {
    }

    // Via bindings
    oppgave: l.OppgaveModell;
    spesifikasjon?: l.MuterendeOppgaveSpesifikasjon;

    // Public props
    statusEnumTallverdier = _(l.Oppgavestatus).filter(enumverdi => _.isNumber(enumverdi)).value()
    state: string; // string rep av aktivStatus for css selector
    aktivStatus: l.Oppgavestatus;
    kanRedigere: boolean;
    iDag: Date = new Date();

    // Private
    private initiellUtfoertDato: Date;

    $onInit() {
        this.kanRedigere = this.oppgaveTjeneste.kanOppgaveRedigeres(this.oppgave);
        this.aktivStatus = this.oppgave.status;
        this.initiellUtfoertDato = this.oppgave.utfoertDato;
        this.oppdaterCss();
    }

    erOppgaveUtfoert() {
        return this.aktivStatus == l.Oppgavestatus.utført;
    }

    /*
     * Hvis spesifikasjon ikke er angitt, antar vi at komponenten er brukt alene, og skal ha autolagring aktivert.
     * Som del av et skjema (spesifikasjon er angitt) skal autolagring være deaktivert
     */
    skalAutolagre() {
        return _.isNil(this.spesifikasjon);
    }

    oppdaterTilstand() {
        this.oppdaterCss();
        this.oppdaterUtførtDatoFelt();
        this.lagre();
    }

    public oversettStatus(status) {
        return this.enumOversettelser.oversettOppgaveStatus(status);
    }

    /**
     * Lager et css-vennlig klassenavn som selectlisten kan bruke for fine farger
     */
    private oppdaterCss() {
        this.state = "selected-" +
          l.Oppgavestatus[this.aktivStatus]
            .replace("å", "aa")
            .replace("ø", "oe");
    }

    /*
     * Ved manuell lagring må vi oppdatere utført dato.
     * Ved auto-lagring håndteres dette av lagre-metoden
     */
    private oppdaterUtførtDatoFelt() {
        if(_.isNil(this.spesifikasjon)) {
            return;
        }
        this.spesifikasjon.status = this.aktivStatus;

        if(this.aktivStatus == l.Oppgavestatus.utført) {
            if(_.isNil(this.spesifikasjon.utfoertDato)) {
                // håndterer at brukeren vingler mellom status-valg uten å endre utførtDato
                this.spesifikasjon.utfoertDato = !_.isNil(this.initiellUtfoertDato) ?
                  this.initiellUtfoertDato : new Date();
            }
        } else {
            this.spesifikasjon.utfoertDato = null;
        }
    }

    private lagre() {
        if(!this.skalAutolagre()) {
            return;
        }

        let spesifikasjon : l.OppgaveStatusSpesifikasjon = {
            id: this.oppgave.id,
            status: this.aktivStatus,
        }

        /*
         * Utført-dato settes kun når oppgaven er utført.
         * I tilfelle brukeren har vinglet mellom statuser, settes utførtDato til eventuell initiell verdi eller nå
         */
        if(this.aktivStatus == l.Oppgavestatus.utført) {
            spesifikasjon.utfoertDato = !_.isNil(this.initiellUtfoertDato) ? this.initiellUtfoertDato : new Date();
        }

        this.oppgaveTjenesteWeb.oppdaterStatus(spesifikasjon)
            .then(_oppgave => {
                // Oppdater modellen (viktig f.eks. for kanban-visningen)
                this.oppgave.utfoertDato = _oppgave.utfoertDato;
                this.oppgave.utfoert = _oppgave.utfoert;
                this.oppgave.status = _oppgave.status;
                // Varsle bruker at det er lagret
                this.meldingTilBruker.infomelding(
                  this.gettextCatalog.getString("Oppgavens status er lagret!"),
                  Varighet.timeout
                );
            });
    }
}
